const LOCAL_STORE_JWT = "chim_jwt";

const isValidMediaURL = (url) => {
  if (!url) return false;

  var res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);

  if (
    url.indexOf("soundcloud.com") !== -1 ||
    url.indexOf("bandcamp.com") !== -1 ||
    url.indexOf("youtube.com") !== -1 ||
    url.indexOf("youtu.be") !== -1
  ) {
    return res !== null;
  }
  return false;
};

export { isValidMediaURL, LOCAL_STORE_JWT };
